import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChartLineConnectedRegularReport from './chart-line-connected-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChartLineConnectedRegularReport {...validProps} />;
}

SvgComponent.iconName = 'chartLineConnectedRegularReport';

export const ChartLineConnectedRegularReportIcon = svgIconWrapper(SvgComponent);
